/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';
import {
    SearchedCompaniesResponseAllOf,
    SearchedCompaniesResponseAllOfFromJSON,
    SearchedCompaniesResponseAllOfFromJSONTyped,
    SearchedCompaniesResponseAllOfToJSON,
} from './SearchedCompaniesResponseAllOf';
import {
    SearchedCompaniesResponseAllOfData,
    SearchedCompaniesResponseAllOfDataFromJSON,
    SearchedCompaniesResponseAllOfDataFromJSONTyped,
    SearchedCompaniesResponseAllOfDataToJSON,
} from './SearchedCompaniesResponseAllOfData';

/**
 * 検索した企業一覧を取得したときのレスポンス
 * @export
 * @interface SearchedCompaniesResponse
 */
export interface SearchedCompaniesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof SearchedCompaniesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof SearchedCompaniesResponse
     */
    message: string;
    /**
     * 
     * @type {SearchedCompaniesResponseAllOfData}
     * @memberof SearchedCompaniesResponse
     */
    data: SearchedCompaniesResponseAllOfData;
}

export function SearchedCompaniesResponseFromJSON(json: any): SearchedCompaniesResponse {
    return SearchedCompaniesResponseFromJSONTyped(json, false);
}

export function SearchedCompaniesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchedCompaniesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': SearchedCompaniesResponseAllOfDataFromJSON(json['data']),
    };
}

export function SearchedCompaniesResponseToJSON(value?: SearchedCompaniesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': SearchedCompaniesResponseAllOfDataToJSON(value.data),
    };
}

